var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container bg-poolsuite"},[_c('router-view'),_c('FooterAppLanding'),_c('PaymentStep'),_c('FooterMain',{staticClass:"mt-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }